export function filterSelections(value) {
  return Array.isArray(value) ? [...value] : value ? [value] : [];
}

export function filterIds(value) {
  const values = filterSelections(value).flatMap((item) =>
    String(typeof item === "object" ? item?.id || "" : item).split(",")
  );
  return [
    ...new Set(
      values
        .map((id) => id.trim())
        .filter((id) => id && id !== "__pool__" && id !== "null")
    ),
  ];
}

export function filterIdsQuery(value) {
  return filterIds(value).join(",");
}

export function isPoolSelection(value) {
  return filterSelections(value).some(
    (item) => item?.isPool || item?.id === "__pool__"
  );
}

// Pool and assigned records cannot be requested together with the API's AND rules.
export function exclusivePoolSelection(value, previous) {
  const selected = filterSelections(value);
  if (!isPoolSelection(selected)) return selected;
  if (!isPoolSelection(previous))
    return selected.filter((item) => item?.isPool || item?.id === "__pool__");
  const assigned = selected.filter(
    (item) => !item?.isPool && item?.id !== "__pool__"
  );
  return assigned.length ? assigned : selected;
}

export async function resolveFilterSelections(value, resolver) {
  return Promise.all(filterIds(value).map((id) => resolver(id)));
}
